import React, { Node } from 'react';
import { compose } from 'ramda';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import styles from './Container.style';
import classNames from 'classnames';

const useStyles = createUseThemeStyles(styles);

type Props = {
  children: Node,
  className?: string,
};

const Container = ({ children, className }: Props) => {
  const classes = useStyles();

  return <div className={classNames(classes.root, className)}>{children}</div>;
};

export default compose(React.memo)(Container);
